import React from 'react';
import './Palletvide.css';
import palletVideo from '../../../video/Palletinject.mp4';

const Palletvide = () => {
  return (
    <div className="video-card">
      <div className="video-container">
        <video controls>
          <source src={palletVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
     
    </div>
  );
};

export default Palletvide;
